/*
  SettingsSection.jsx
*/

// Npm.
import React from 'react';

// Components.
import Selector from '../../Selector';
import Switch from '../../Switch';

// Makes.
import { makeStyles } from '../../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    width: '100%',
    '& > tbody > tr > td': {
      padding: '2px 0',
      width: '50%',
    }
  }
}));

/**
 * Left sidebar component.
 */
export default function SettingsSection({
  className,
  disabled = false,
  disableThemeToggle = false,
  graphSettings,
  onChangeGraphSettings,
}) {

  // Class.

  const classes = useStyles();

  let useClass = `${classes.root} body2`;

  if (className) {
    useClass += ` ${className}`;
  }

  // Handlers.

  function changeSettings(fields) {
    if (onChangeGraphSettings) {
      onChangeGraphSettings(obj => ({ ...obj, ...fields }));
    }
  }

  return (
    <table className={useClass}>
      <tbody>
        <tr>
          <td>Arrows</td>
          <td>
            <Selector
              value={graphSettings.arrows || 0}
              onChange={(event) => changeSettings({ arrows: Number(event.target.value) })}
              fullWidth
              size="small"
              disabled={disabled}
            >
              <option value="0">Off</option>
              <option value="1">Small</option>
              <option value="2">Large</option>
            </Selector>
          </td>
        </tr>
        {/*<tr>
          <td>Particles</td>
          <td>
            <Selector
              value={graphSettings.particles}
              onChange={(event) => changeSettings({ particles: Number(event.target.value) })}
              fullWidth
              size="small"
              disabled={disabled}
            >
              <option value="0">Off</option>
              <option value="1">Some</option>
              <option value="2">Many</option>
            </Selector>
          </td>
        </tr>*/}
        <tr>
          <td>Node Labels</td>
          <td>
            <Selector
              value={graphSettings.nodeLabels || 0}
              onChange={(event) => changeSettings({ nodeLabels: Number(event.target.value) })}
              fullWidth
              size="small"
              disabled={disabled}
            >
              <option value="0">Off</option>
              <option value="1">Hover</option>
              <option value="2">On</option>
            </Selector>
          </td>
        </tr>
        <tr>
          <td>Link Labels</td>
          <td>
            <Selector
              value={graphSettings.linkLabels || 0}
              onChange={(event) => changeSettings({ linkLabels: Number(event.target.value) })}
              fullWidth
              size="small"
              disabled={disabled}
            >
              <option value="0">Off</option>
              <option value="1">Hover</option>
            </Selector>
          </td>
        </tr>
        <tr>
          <td>Physics</td>
          <td>
            <Selector
              value={graphSettings.physics || 0}
              onChange={(event) => changeSettings({ physics: Number(event.target.value) })}
              fullWidth
              size="small"
              disabled={disabled}
            >
              <option value="0">Off</option>
              <option value="1">Some</option>
              <option value="2">Strong</option>
            </Selector>
          </td>
        </tr>
        {
          !disableThemeToggle &&
          <tr>
            <td>Dark Mode</td>
            <td>
              <Switch
                checked={graphSettings.isDark || false}
                onChange={(event) => changeSettings({ isDark: event.target.checked })}
                disabled={disabled}
              />
            </td>
          </tr>
        }
      </tbody>
    </table>
  );
}
